module.exports = __webpack_public_path__ + "media/img/pages/career-starter/04-5da1c1859a5181af81f1a7758338a708.png";